module.exports = __webpack_public_path__ + "static/media/gp.67c0ca9d.webp";